import {Component, Input, OnInit} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {titleTemplateAnimation} from '../../animations/title-template.animation';


export class LeafPageTemplate implements OnInit {

     title: string;

    ngOnInit(): void {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: '[leaf-page-template]',
    template: `
        <div class="row wrapper border-bottom white-bg page-heading ng-scope" *ngIf="title"
             [@titleTemplateAnimation]>
            <div [ngClass]="{'col-sm-4': (titleRightWrapper.children.length > 0), 'col-sm-12' : (titleRightWrapper.children.length === 0)}">
                <h2 class="m-b-xxs">{{ title }}</h2>
            </div>
            <div class="col-sm-8" [ngClass]="{'hidden': titleRightWrapper.children.length === 0}">
                <div class="pull-right m-t-md" #titleRightWrapper>
                    <ng-content select="[title-right]"></ng-content>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="wrapper wrapper-content">
                    <ng-content select="[content]"></ng-content>
                </div>
            </div>
        </div>
    `,
    animations: [titleTemplateAnimation]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
